'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@module/lib/utils';
import useChatPanelStore from '@module/stores/useChatPanelStore';
import { Skeleton } from '@pc/components/ui/skeleton';
import { usePathname } from 'next/navigation';
function BroadcastUserItemSkeleton() {
  const $ = _c(6);
  const pathname = usePathname();
  const {
    isChatPanelOpen
  } = useChatPanelStore();
  let t0;
  if ($[0] !== isChatPanelOpen || $[1] !== pathname) {
    const isPlayPage = pathname.includes("/play");
    t0 = cn("w-1/4 xxxl:w-[16.5%] pr-[20px] pb-[28px] lg:w-1/5 xl:w-1/6", {
      "w-1/3 lg:w-1/4 xl:w-1/5": isPlayPage && isChatPanelOpen
    });
    $[0] = isChatPanelOpen;
    $[1] = pathname;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="h-full break-all"><div className="relative block overflow-hidden rounded-[8px] bg-center bg-cover bg-video-thumbnail bg-no-repeat pt-[56.25%]"><Skeleton className="absolute inset-0 top-0 left-0 h-full w-full rounded-lg" /></div><Skeleton className="mt-3 h-[45px] w-full" /></div>;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0) {
    t2 = <li className={t0}>{t1}</li>;
    $[4] = t0;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export default BroadcastUserItemSkeleton;